<div *transloco="let t; currentLang as currentLang"
  class="report-panel relative flex w-full flex-col items-start md:mb-6 gap-3 rounded-[10px] border-[1.5px] border-[#E4E7EC] bg-[#FEF3F2] px-3 py-3 md:px-5 md:py-2.5">
  <div class="flex w-full items-center justify-between gap-4">
    <p class="text-sm font-semibold leading-5 text-[#D92D20] md:text-base md:leading-6">
      Report this Job / Company (রিপোর্ট)
    </p>

    <a (click)="openReportModal()"
      class="flex shrink-0 cursor-pointer items-center justify-center min-w-[93px] min-h-[36px] gap-1 rounded-lg border border-[#D0D5DD] bg-white px-3 py-2 text-sm font-semibold leading-5 text-[#333333] shadow-[0_1px_2px_rgba(16,24,40,0.05),inset_0_0_0_1px_rgba(16,24,40,0.18),inset_0_-2px_0_rgba(16,24,40,0.05)] "
      id="reportbutton">
      <img src="images/flag-01.svg" alt="" class="h-5 w-5 shrink-0">
      <span class="px-0.5 ">রিপোর্ট</span>
    </a>
  </div>



  <p class="report-copy w-full text-xs font-normal leading-[18px] text-[#475467] md:mt-2 md:text-sm md:leading-5">
    এই চাকরির জন্য বিজ্ঞাপনদাতা ব্যক্তি/প্রতিষ্ঠান আপনার কাছ থেকে কোন অর্থ চাইলে কিংবা নিয়োগ প্রক্রিয়া চলাকালীন কোন
    প্রকার
    হয়রানি মূলক (শারীরিক/মানসিক) আচরণ করলে অতিসত্বর আমাদেরকে জানান অথবা জবটি রিপোর্ট করুন। চাকরি পাওয়ার জন্য কোন
    ব্যক্তি/প্রতিষ্ঠানকে অর্থ প্রদান করবেন না। চাকরিকালীন কোন প্রকার হয়রানির (শারীরিক/মানসিক) সম্ভাবনা থাকলে সেখানে জয়েন
    করবেন না। কোন প্রকার অর্থ লেনদেন বা নিয়োগদাতা কর্তৃক হয়রানির দায়িত্ব বিডিজবস বহন করবে না।
  </p>

  @if (c2c() === '1') {
  <p class="report-copy w-full text-xs font-normal leading-[18px] text-[#475467] md:mt-2 md:text-sm md:leading-5">
    এটি একটি ক্লাসিফাইড পোস্টিং। এই জবের কনটেন্ট বিডি জবস কর্তৃক ভেরিফাইড না। এপ্লাই করার ক্ষেত্রে জবের কনটেন্টটি
    ভালোমতো
    পড়ে সতর্কতার সহিত আবেদন করতে চাকরি প্রার্থীদেরকে অনুরোধ করা যাচ্ছে।
  </p>
  }

  <div
    class="report-contacts flex w-full flex-col items-start justify-center gap-2.5 text-xs font-medium leading-[18px] text-[#772454] md:flex-row md:flex-wrap md:items-center md:justify-start md:gap-3 md:text-sm md:leading-5 md:text-[#10557C]">
    <div class="flex items-center gap-3">
      <img src="images/phone-call-02.svg" alt="" class="h-4 w-4 shrink-0 md:h-5 md:w-5">
      <span>
        <a href="tel:09638666444" aria-label="For any assistance please contact 09638666444">09638666444</a>,
        <a href="tel:01897627858" aria-label="For any assistance please contact 01897627858">01897627858</a>
      </span>
    </div>
    <img src="images/ellipse-52.svg" alt="" class="hidden h-1.5 w-1.5 shrink-0 md:block">
    <div class="flex items-center gap-3">
      <img src="images/mail-01.svg" alt="" class="h-4 w-4 shrink-0 md:h-5 md:w-5">
      <span>complain&#64;bdjobs.com</span>
    </div>
  </div>
</div>




@if (isReportModalOpen) {
<app-report-job-modal [reportForm]="ReportForm" [reportTypes]="reportTypes" (closed)="closeReportModal()"
  (submitted)="onSubmit()"></app-report-job-modal>
}